// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8c434d358eb6b13781f2b8362b7a5e9495e4f14a.chunk.bundle.js";
};